<template>
  <div class="overlay" id="id">
      <v-layout>
        <v-flex xs12>
          <ul style="list-style:none;padding-left: 0;">
            <li v-for="(error, index) in errors" v-bind:key="index">
              <wes-error
                v-bind:index="index"
                v-bind:error="error"
                v-on:closeError="onCloseErrorClicked"
								v-on:show="showAllWarnings"
              ></wes-error>
            </li>
          </ul>
        </v-flex>
      </v-layout>
    <!-- </v-container> -->
  </div>
</template>

<script>
/**
 * This is a container for the validation banner messages that sit at the top of the questions.
 */
export default {
  name: 'WesErrorPanel',
  props: {
    // id is the quesion id
    id: String
  },
  created: function () {
    console.log('hola mudo fuc');
  },
  methods: {
    onCloseErrorClicked: function (val) {
      // this.errors.splice(val, 1);
      // if(0 === this.errors.length) {
      this.$emit('closeerrorpanel');
      // }
		},
		showAllWarnings: function (val) {
			var questionInfo = {
				id: this.id
			}

			this.$store.dispatch('validation/showAllDismissed', questionInfo);
		}
	},
	computed: {
		errors () {
			return this.$store.getters['validation/validationMessagesForQuestionBanner'](this.id);
		}
	}
};
</script>

<style scoped>
.overlay {
  /*position: absolute;*/
  overflow: hidden;
  /* border: 5px solid #f44336; */
  border-radius: 5px;
  left: 5px;
  right: 5px;
  top: 5px;
  display: block;
  z-index: 10;
  /* background-color: #eeeeee; */
  color: #f44336;
}
.question-number.hide {
  display: none;
}
</style>
